import classNames from "classnames";
import { Form } from "formik";
import { AppProps } from "../AppProps";

// Component for rendering a vertical form layout
export function VerticalForm({ children, className }: AppProps): JSX.Element {
// Generate class names for the form component based on provided and default classes
  const componentClasses = classNames(
    className, // Additional classes passed to the component
    'flex flex-col items-start' // Default classes for a flex container with vertical alignment
  );

  // Render the component with specified class names and child components
  return (
    <Form className={componentClasses}>
      {children}
    </Form>
  );
}
